import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ContextoService } from '../services/contexto.service';
import { HTTP_HEADERS } from '../constants/http-headers.constants';

export const empresaInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const contextoService = inject(ContextoService);
  
  const urlsExcluidas = [
    '/oauth2/',
    '/token',
    '/authorize',
    'login.microsoftonline.com',
    'graph.microsoft.com',
    'ciamlogin.com'
  ];

  const esUrlExcluida = urlsExcluidas.some(url => req.url.includes(url));

  if (esUrlExcluida) {
    return next(req);
  }

  const tieneHeaderOrg = req.headers.has(HTTP_HEADERS.X_FACTO_ORG);
  const tieneHeaderRol = req.headers.has(HTTP_HEADERS.X_FACTO_ROL);

  if (tieneHeaderOrg || tieneHeaderRol) {
    return next(req);
  }

  const contextoActivo = contextoService.obtenerContextoActivo();

  if (!contextoActivo) {
    return next(req);
  }

  const headers: Record<string, string> = {};

  const rolActivo = contextoActivo.roles?.[0];
  if (rolActivo) {
    headers[HTTP_HEADERS.X_FACTO_ROL] = rolActivo;
  }

  if (contextoActivo.orgId) {
    headers[HTTP_HEADERS.X_FACTO_ORG] = contextoActivo.orgId;
  }

  const reqClonado = req.clone({
    setHeaders: headers
  });

  return next(reqClonado);
};
